













// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import EditBaseForfait from '@/components/administration/forfait/edit/EditBaseForfait.vue'
import * as rules from '@/utils/validationRules'
import { toStringDictionary } from '@/utils/groupBy'
import { getDefaultAloForfait } from '@/models/alo/AloForfait'
import { AloForfait } from '@/models/alo/AloForfait'

@Component({
  name: 'EditContent',     
  components:{EditBaseForfait}
})
export default class EditContent extends Vue {
      
  private forfait:AloForfait = getDefaultAloForfait()

  edit(item:AloForfait) {    
    this.forfait = (this.$refs.baseEdit as EditBaseForfait).edit(item)    
  }

 
  ruleRequired(v:string) {
    return rules.ruleRequired(v)
  }  
      
}
